export default function booleanSelectValue(value) {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return String(value);
}